import React from 'react';

export const scrollIntoViewOptionsCenter: ScrollIntoViewOptions = {
    block: 'center',
    inline: 'center',
    behavior: 'smooth',
};
const fieldErrorSelector = '#errorWrapper';

export const useScrollToError = (isValid: boolean, isSubmitting: boolean) => {
    React.useEffect(() => {
        if (!isValid && isSubmitting) {
            const errorElement = document.querySelectorAll<HTMLInputElement>(fieldErrorSelector)[0];
            if (errorElement) {
                errorElement.scrollIntoView(scrollIntoViewOptionsCenter);
            }
        }
    }, [isValid, isSubmitting]);
};
